export const CompanyHead = ({ c, title, no, sub, brand }) => (
  <div className="flex justify-between items-start border-b-2 border-slate-900 pb-3 mb-4 gap-6" data-testid="print-company-head">
    <div className="flex gap-3 items-start">
      {c?.logo_url ? <img src={`${process.env.REACT_APP_BACKEND_URL}${c.logo_url}`} alt="Logo" className="h-14 w-auto object-contain" data-testid="print-company-logo" />
        : <div className="h-14 w-14 border border-dashed border-slate-300 text-[9px] text-slate-400 flex items-center justify-center text-center" data-testid="print-logo-placeholder">LOGO</div>}
      <div className="text-[11px] text-slate-600 leading-snug">
        <div className="text-base font-bold text-slate-900" data-testid="print-company-title">{brand || c?.title || "İmamoğlu A.Ş"}</div>
        {c?.address && <div>{c.address}</div>}
        {(c?.tax_office || c?.tax_no) && <div>V.D.: {c.tax_office || "—"} · V.No: {c.tax_no || "—"}</div>}
        {(c?.phone || c?.email) && <div>{[c.phone, c.email].filter(Boolean).join(" · ")}</div>}
        {c?.iban && <div>IBAN: <span className="font-mono">{c.iban}</span></div>}
      </div>
    </div>
    <div className="text-right shrink-0">
      <div className="text-lg font-bold uppercase" data-testid="print-doc-title">{title}</div>
      <div className="font-mono text-sm" data-testid="print-doc-no">{no}</div>
      {sub && <div className="text-[11px] text-slate-500">{sub}</div>}
    </div>
  </div>
);

export const Sign = ({ labels }) => (
  <div className={`grid ${labels.length === 3 ? "grid-cols-3" : "grid-cols-2"} gap-8 mt-12 text-[12px]`} data-testid="print-signatures">
    {labels.map((l) => <div key={l} className="border-t border-slate-400 pt-1 text-center text-slate-600 min-h-[48px]">{l}</div>)}
  </div>
);
